"use client";

import Custom404 from '../components/UverceeComponents/Error/Custom404';
 
export default function NotFoundPage() {
  return (
    <>
      <Custom404 />
    </>
  )
}